export default [{
  path: '/requirements',
  name: 'requirements',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/requirements/index')
}]
